import { useState, useEffect, useRef } from "react";
import {
  Grid,
  Box,
  TextField,
  Typography,
  InputAdornment,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GetUserId, GetUserInfo } from "../../../_utilities/getUserInfo";
import * as _ser from "../../../_redux/_services/ApplicantsSlice";
import * as _props from "../../../_redux/_services/JobPostingSlice";
import { customFieldsAsync } from "../../../_redux/_services/UserManagerSlice";
import { resetHighlightFilter, setHighlightFilter } from "../../../_redux/HighlightSlice";
import NewApplicantCard from "./New_ApplicantCard/NewApplicantCard";
import AdvancedSearch from "../../../components/AdvancedSearch/AdvancedSearch";
import { DashboardPlusicon } from "../../../Icons/DashboardPlusicon";
import "./applicantlist.css";
import { ApplicantListfloatingMenuOptions } from "../../../constants/floatingMenuConstants";
import {
  resetSelectedApplicant,
  setSelectedApplicant,
} from "../../../_redux/SelectedApplicantSlice";
import ApplicantsDetailsTabs from "../ApplicantDetails/ApplicantsDetailsTabs/ApplicantsDetailsTabs";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import CloseIcon from "@mui/icons-material/Close";
import Pagination from "../../../components/DynamicTable/Pagination";
import ApplicantsCreateFlow from "../ApplicantsCreateFlow/ApplicantsCreateFlow";
import ViewToggle from "../../../components/ViewToggle";
import {
  formatCurrentWorkExp,
  formatEducation,
} from "../../../_utilities/utilities";
import { scrollToElement } from "../../../_utilities/scrollHelper";
import GetJobId from "../../../_utilities/GetJobId";
import FloatingMenu from "../../../components/FloatingMenu/FloatingMenu";
import { safeJSONParse } from "../../../_utilities/constants";

const initalState = { data: null, message: "", isloader: true };

/* ---------------- MAIN COMPONENT ---------------- */
const ApplicantsList = () => {
  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const [isAdvancePannel, setIsAdvancePannel] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isRightSidePannel, setIsRightSidePannel] = useState(true);
  const [showAppliantDetailsById, setShowAppliantDetailsById] = useState(null);
  const [minimiseRightSection, setMinimiseRightSection] = useState(false);
  const [componetType, setComponentType] = useState("");
  const [users, setUsers] = useState([]);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [SelectedApplicantIds, setSelectedApplicantIds] = useState([]);
  const [isResetTabs, setIsResetTabs] = useState(false);
  const [warningPopupDetails, setWarningPopupDetails] = useState({
    title: "",
    title1: "",
    btnName: "",
    type: "",
  });
  const [advancedSearch, setAdvancedSearch] = useState(null);
  const [advancedSearchObj, setAdvancedSearchObj] = useState(null);
  const cardRefs = useRef({});
  const gridRef = useRef(null);
  const [showNoData, setShowNoData] = useState(false);
  const [tooltipCardId, setTooltipCardId] = useState(null);
  const [showSelectAllTip, setShowSelectAllTip] = useState(
    sessionStorage.getItem("hasSeenSelectAllApplicantsTip") !== "true",
  );

  const handleTooltipDismiss = () => {
    setShowSelectAllTip(false);
    setTooltipCardId(null);
    sessionStorage.setItem("hasSeenSelectAllApplicantsTip", "true");
  };

  const handleSelectAll = (isChecked) => {
    const updatedList = applicantsList.map((item) => ({
      ...item,
      isChecked: isChecked,
    }));
    setApplicantsList(updatedList);

    if (isChecked) {
      const newSelected = [...SelectedApplicantIds];
      updatedList.forEach((item) => {
        if (!newSelected.some((x) => x.id === item.id)) {
          newSelected.push(item);
        }
      });
      setSelectedApplicantIds(newSelected);
    } else {
      const currentIds = updatedList.map((item) => item.id);
      setSelectedApplicantIds(
        SelectedApplicantIds.filter((item) => !currentIds.includes(item.id)),
      );
    }
    handleTooltipDismiss();
  };

  const dispatch = useDispatch();
  const location = useLocation();

  const recruiterList = useSelector(
    (state) => state.GetManagerTeamlead.recruiter,
  );
  const customFieldsData = useSelector((state) => state.CustomFields.data);
  const { storedApplicant } = useSelector((state) => state.SelectedApplicant);
  const { systemRole } = useSelector((state) => state.Auth);
  const isFieldRecruiter = systemRole === "Field Recruiter";
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  const showLoader = useSelector((state) => state.Loader.value);
  const showUncommonLoader = useSelector((state) => state.UncommonLoader.value);

  const applicantsFromRedux = useSelector(
    (state) => state.GetListApplicants.data,
  );
  const SearchApplicantsWithoutPagingData = useSelector(
    (state) => state.SearchApplicantsWithoutPaging.data,
  );

  const SearchApplicantsWithPagingData = useSelector(
    (state) => state.SearchApplicantsWithPaging.data,
  );

  const advSearchParams = useSelector((state) => state.Highlight.initialParams);

  const [applicantsList, setApplicantsList] = useState([]);
  const [config, setConfig] = useState({
    currentPage: 1,
    limitData: 9,
    offset: 1,
    totalRecords: 0,
    totalRecordsCount: 0,
  });
  const warningPopupEnum = {
    DELETE: {
      title: "Are you sure you want to delete this Applicant?",
      title1: "This action cannot be undone.",
      btnName: "Delete",
      type: "delete",
    },
  };

  useEffect(() => {
    if (componetType === "") {
      setSelectedApplicantIds([]);
    }
  }, [componetType]);

  useEffect(() => {
    console.log("showAppliantDetailsById ++++++++", showAppliantDetailsById);
  }, [showAppliantDetailsById])

  useEffect(() => {
    let timer;
    if (applicantsList.length === 0 && !showLoader && !showUncommonLoader) {
      timer = setTimeout(() => {
        setShowNoData(true);
      }, 2000);
    } else {
      setShowNoData(false);
    }
    return () => clearTimeout(timer);
  }, [applicantsList, showLoader, showUncommonLoader]);

  // Handle search results from Redux
  useEffect(() => {
    if (
      SearchApplicantsWithoutPagingData &&
      (SearchApplicantsWithoutPagingData.length > 0 ||
        SearchApplicantsWithoutPagingData.rows?.length > 0)
    ) {
      const applicantsWithoutPagingData = JSON.parse(
        JSON.stringify(SearchApplicantsWithoutPagingData),
      );
      let myData =
        applicantsWithoutPagingData?.rows || applicantsWithoutPagingData;
      const total_count =
        applicantsWithoutPagingData?.total_count ||
        applicantsWithoutPagingData[0]?.total_count;

      if (myData && Array.isArray(myData)) {
        myData.forEach((e) => {
          e["isChecked"] = false;
          // Map API data fields to component expected fields
          if (!e.id && e.applicantCode) {
            e["id"] = e.applicantCode;
          }
          if (!e.name && (e.firstName || e.lastName)) {
            e["name"] = `${e.firstName || ""} ${e.lastName || ""}`.trim();
          }
          if (!e.role && e.jobTitle) {
            e["role"] = e.jobTitle;
          }
          if (!e.experience && e.yearsOfExperience) {
            e["experience"] = `${e.yearsOfExperience} Years`;
          }
          if (!e.location && (e.city || e.state)) {
            e["location"] = `${e.city || ""} ${e.state || ""}`.trim();
          }
          // if (e.skills) {
          //   const parsed =
          //     typeof e.skills === 'string' ? JSON.parse(e.skills) : e.skills;

          //   e.formattedSkills = Array.from(
          //     new Set(parsed.map((skill) => skill.name))
          //   );
          //   // e['formattedSkills'] = e.formattedSkills;
          // }
          if (e.skills) {
            let parsedSkills = e.skills;

            try {
              // Step 1: Parse if string
              if (typeof parsedSkills === "string") {
                parsedSkills = JSON.parse(parsedSkills);

                // Step 2: Handle double-stringified JSON
                if (typeof parsedSkills === "string") {
                  parsedSkills = JSON.parse(parsedSkills);
                }
              }

              // Step 3: Normalize to array of names
              let skillNames = [];

              if (Array.isArray(parsedSkills)) {
                skillNames = parsedSkills.map((skill) => {
                  if (typeof skill === "string") return skill;
                  if (typeof skill === "object" && skill.name)
                    return skill.name;
                  return null;
                });
              }

              // Step 4: Clean + deduplicate
              e.formattedSkills = Array.from(
                new Set(skillNames.filter(Boolean)),
              );
            } catch (err) {
              console.error("Skills parsing failed", err);
              e.formattedSkills = [];
            }
          }
          if (e.educationDetails) {
            const edu = formatEducation(e.educationDetails);

            if (edu) {
              e.education = edu.education;
              e.educationPeriod = edu.educationPeriod;
            }
          }
          if (e.workExp) {
            const work = formatCurrentWorkExp(e.workExp);

            if (work) {
              e.company = work.company;
              e.companyPeriod = work.companyPeriod;
              e.role = work.role;
            }
          }
        });
        let configure = JSON.parse(JSON.stringify(config));
        configure.totalRecords = total_count;
        configure.totalRecordsCount = total_count;
        setConfig(configure);
        setApplicantsList(myData);
        dispatch(_ser.searchApplicantsWithoutPagingStartReducer(initalState));
      }
    } else if (SearchApplicantsWithoutPagingData) {
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = 0;
      configure.currentPage = 1;
      configure.totalRecordsCount = 0;
      setConfig(configure);
      setApplicantsList([]);
      dispatch(_ser.searchApplicantsWithoutPagingStartReducer(initalState));
    }
  }, [SearchApplicantsWithoutPagingData, dispatch, config]);

  useEffect(() => {
    if (
      SearchApplicantsWithPagingData &&
      (SearchApplicantsWithPagingData.length > 0 ||
        SearchApplicantsWithPagingData?.rows?.length > 0)
    ) {
      const applicantsWithPagingData = JSON.parse(
        JSON.stringify(SearchApplicantsWithPagingData),
      );
      let myData = applicantsWithPagingData?.rows || applicantsWithPagingData;
      const total_count = applicantsWithPagingData?.total_count; // || applicantsWithPagingData[0].total_count;
      myData.forEach((e) => {
        e["isChecked"] = false;
        if (!e.id && e.applicantCode) {
          e["id"] = e.applicantCode;
        }
        if (!e.name && (e.firstName || e.lastName)) {
          e["name"] = `${e.firstName || ""} ${e.lastName || ""}`.trim();
        }
        if (!e.role && e.jobTitle) {
          e["role"] = e.jobTitle;
        }
        if (!e.experience && e.yearsOfExperience) {
          e["experience"] = `${e.yearsOfExperience} Years`;
        }
        if (!e.location && (e.city || e.state)) {
          e["location"] = `${e.city || ""} ${e.state || ""}`.trim();
        }
        if (e.skills) {
          const parsed =
            typeof e.skills === "string" ? safeJSONParse(JSON.parse(e.skills)) : e.skills;

          e.formattedSkills = Array.from(
            new Set(parsed?.map((skill) => skill.name)),
          );
        }
        if (e.educationDetails) {
          const edu = formatEducation(e.educationDetails);

          if (edu) {
            e.education = edu.education;
            e.educationPeriod = edu.educationPeriod;
          }
        }
        if (e.workExp) {
          const work = formatCurrentWorkExp(e.workExp);

          if (work) {
            e.company = work.company;
            e.companyPeriod = work.companyPeriod;
            e.role = work.role;
          }
        }
      });
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = total_count;
      configure.totalRecordsCount = total_count;
      setConfig(configure);
      // setUsers(myData.slice(0, config.limitData));
      setApplicantsList(myData);
      dispatch(_ser.searchApplicantsWithPagingStartReducer(initalState));
    } else if (
      SearchApplicantsWithPagingData?.rows ||
      SearchApplicantsWithPagingData
    ) {
      //&& SearchApplicantsWithPagingData.length === 0
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = 0;
      configure.currentPage = 1;
      configure.totalRecordsCount = 0;
      setConfig(configure);
      setApplicantsList([]);
      dispatch(_ser.searchApplicantsWithPagingStartReducer(initalState));
    }
  }, [SearchApplicantsWithPagingData]);

  // Load initial applicants
  useEffect(() => {
    async function init() {
      const userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
    }
    init();

    // If we land on the list page without a specific applicant in URL or History State,
    // clear the Redux selection to prevent "stale" details on reload.
    const pathnameParts = location.pathname.split("/");
    const isIdInUrl = /^\d+$/.test(pathnameParts[pathnameParts.length - 1]);
    const isIdInState = !!location.state?.selectedApplicant;

    if (!isIdInUrl && !isIdInState) {
      // dispatch(resetSelectedApplicant());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Sync selection with browser history state
  useEffect(() => {
    const pathnameParts = location.pathname.split("/");
    const lastSegment = pathnameParts[pathnameParts.length - 1];
    const isId = /^\d+$/.test(lastSegment);
    if (!isId) return;
    const isOpenedInNewTab = !!window.opener;
    if (isOpenedInNewTab) {
      setShowAppliantDetailsById({ id: lastSegment, isOpenedInNewTab: true })
    } else {
      dispatch(setSelectedApplicant({ id: lastSegment }));
    }
    const search = location.search || "";
    const timer = setTimeout(() => {
      navigate(`/ats/layout/applicants/list/landing${search}`, {
        replace: true,
      });
    }, 200);
    return () => clearTimeout(timer);
  }, [location.pathname, location.search, dispatch, navigate]);

  // NEW: Sync selection with browser history state for Back Button support
  useEffect(() => {
    if (location.state?.selectedApplicant) {
      const item = location.state.selectedApplicant;
      if (storedApplicant?.id !== item.id) {
        setShowAppliantDetailsById(item);
        setIsRightSidePannel(false);
        setIsAdvancePannel(false);
        if(!location.state?.isDocument){
          setIsResetTabs(true);
        }
        dispatch(setSelectedApplicant({ applicantDetails: item }));
      }
    } else {
      // If we are NOT in the middle of a URL-cleaning operation (the existing effect above),
      // then a null state means we should close the panel (e.g. Back button was clicked)
      const pathnameParts = location.pathname.split("/");
      const isId = /^\d+$/.test(pathnameParts[pathnameParts.length - 1]);

      if (!isId) {
        const isOpenedInNewTab = !!window.opener;
        if (!isOpenedInNewTab) {
          if(!location.state?.selectedApplicant){
            dispatch(resetSelectedApplicant());
          }
          setShowAppliantDetailsById(null);
        }
        setMinimiseRightSection(false);
        if (advancedSearch && Object.keys(advancedSearch).length > 0) {
          setIsAdvancePannel(true);
        }
      }
    }
    scrollToElement("applicant-new");
  }, [location.state, advancedSearch, dispatch, location.pathname, storedApplicant?.id]);

  // Handle initial applicants data
  useEffect(() => {
    if (
      applicantsFromRedux &&
      applicantsFromRedux.rows &&
      applicantsFromRedux.rows.length > 0
    ) {
      const myData = JSON.parse(JSON.stringify(applicantsFromRedux.rows));
      myData.forEach((e) => {
        e["isChecked"] = false;
        // Map API data fields to component expected fields
        if (!e.id && e.applicantCode) {
          e["id"] = e.applicantCode;
        }
        if (!e.name && (e.firstName || e.lastName)) {
          e["name"] = `${e.firstName || ""} ${e.lastName || ""}`.trim();
        }
        if (!e.role && e.jobTitle) {
          e["role"] = e.jobTitle;
        }
        if (!e.experience && e.yearsOfExperience) {
          e["experience"] = `${e.yearsOfExperience} Years`;
        }
        if (!e.location && (e.city || e.state)) {
          e["location"] = `${e.city || ""} ${e.state || ""}`.trim();
        }
        // if (e.skills) {
        //   const parsed =
        //     typeof e.skills === 'string' ? JSON.parse(e.skills) : e.skills;

        //   e.formattedSkills = Array?.from(
        //     new Set(parsed?.map((skill) => skill.name))
        //   );
        //   // e['formattedSkills'] = e.formattedSkills;
        // }
        if (e.skills) {
          let parsedSkills = e.skills;

          try {
            // Step 1: Parse if string
            if (typeof parsedSkills === "string") {
              parsedSkills = JSON.parse(parsedSkills);

              // Step 2: Handle double-stringified JSON
              if (typeof parsedSkills === "string") {
                parsedSkills = JSON.parse(parsedSkills);
              }
            }

            // Step 3: Normalize to array of names
            let skillNames = [];

            if (Array.isArray(parsedSkills)) {
              skillNames = parsedSkills.map((skill) => {
                if (typeof skill === "string") return skill;
                if (typeof skill === "object" && skill.name) return skill.name;
                return null;
              });
            }

            // Step 4: Clean + deduplicate
            e.formattedSkills = Array.from(new Set(skillNames.filter(Boolean)));
          } catch (err) {
            console.error("Skills parsing failed", err);
            e.formattedSkills = [];
          }
        }

        if (e.educationDetails) {
          const edu = formatEducation(e.educationDetails);

          if (edu) {
            e.education = edu.education;
            e.educationPeriod = edu.educationPeriod;
          }
        }
        if (e.workExp) {
          const work = formatCurrentWorkExp(e.workExp);

          if (work) {
            e.company = work.company;
            e.companyPeriod = work.companyPeriod;
            e.role = work.role;
          }
        }
      });
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = applicantsFromRedux.total_count;
      configure.totalRecordsCount = applicantsFromRedux.total_count;
      // configure.currentPage = 1;
      setConfig(configure);
      setApplicantsList(myData);
      dispatch(_ser.getListApplicantsStartReducer(initalState));
    }
    // If no API data, keep displaying mock data (already set in initial state)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicantsFromRedux, dispatch]);

  useEffect(() => {
    async function getRecruiter() {
      if (recruiterList?.length > 0) {
        const data = JSON.parse(JSON.stringify(recruiterList));
        let newArray = [];
        data.forEach((list) => {
          let obj = {
            id: list.id.toString(),
            name: `${list.firstName} ${list.lastName}`,
            emailId: list.emailId,
          };
          newArray.push(obj);
        });
      } else {
        let userId = await GetUserId();
        dispatch(_props.getManagerTeamleadAsync(" ", userId));
      }
    }
    getRecruiter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, recruiterList]);

  const handleApplyAdvancedSearch = (params, object, page = 1) => {
    if (Object.keys(params).length > 0) {
      setAdvancedSearch(params);
      if (page === 1) {
        setAdvancedSearchObj(object || null);
      }
    }
    const searchParams = {
      offset: page !== 1 ? (page - 1) * config.limitData + 1 : 1,
      limit: config.limitData,
      ...params,
    };
    const { location, type, ...filteredParams } = params;
    dispatch(
      _ser.searchApplicantsWithoutPagingAsync(
        { ...filteredParams, type },
        searchParams,
      ),
    );

    const generateObj = Object.entries(params).reduce((acc, [key, value]) => {
      if (key === "recruiterId") return acc; // ✅ skip this key
      if (key === "custom" && Array.isArray(value)) {
        value.forEach((item, index) => {
          acc[`custom${index + 1}`] = item?.value ?? "";
        });
      } else {
        acc[key] = Array.isArray(value) ? value.join(",") : value;
      }
      return acc;
    }, {});

    dispatch(
      setHighlightFilter({
        advSearch:
          {
            ...generateObj,
            ...(object?.recruiter && { recruiter: object.recruiter }),
            location,
          } || {},
        params: params,
      }),
    );
  };

  const handleCloseAdvancedSearch = () => {
    setIsAdvancePannel(false);
  };

  const handleClearAdvancedFilters = () => {
    dispatch(resetHighlightFilter());
    setAdvancedSearch(null);
    setAdvancedSearchObj(null);
    if (searchQuery !== "" && searchQuery.length >= 2) {
      dispatch(
        _ser.searchApplicantsWithPagingAsync(config.limitData, 1, searchQuery),
      );
    } else {
      let modifyConfig = { ...config };
      modifyConfig.currentPage = 1;
      modifyConfig.offset = 1;
      setConfig(modifyConfig);
      dispatch(_ser.getListApplicantsAsync(modifyConfig.limitData, 1));
    }
  };

  useEffect(() => {
    if (storedApplicant !== null) {
      setIsAdvancePannel(false);
      setIsRightSidePannel(false);
      setShowAppliantDetailsById(storedApplicant);
      handleTooltipDismiss();
      const hasAdvancedSearch =
        advancedSearch && Object.keys(advancedSearch).length > 0;
      if (hasAdvancedSearch) {
        const generateObj = Object.entries(advancedSearch).reduce(
          (acc, [key, value]) => {
            if (key === "custom" && Array.isArray(value)) {
              acc[key] = value.map((item) => item?.value).filter(Boolean).join(",");
              return acc;
            }
            acc[key] = Array.isArray(value) ? value.toString() : value;
            return acc;
          },
          {},
        );
        dispatch(
          setHighlightFilter({
            advSearch: { ...generateObj, ...(advancedSearchObj || {}) } || {},
          }),
        );
      }
    } else {
      const isOpenedInNewTab = !!window.opener;
      if (!isOpenedInNewTab) {
        setShowAppliantDetailsById(null);
      }
      setMinimiseRightSection(false);
    }
  }, [storedApplicant]);

  const onReceivepropsHandler = (item, type) => {
    if (type === "view") {
      if (showAppliantDetailsById?.id === item.id) {
        return;
      }
      setIsAdvancePannel(false);
      setIsResetTabs(true);
      const appliantObj = {
        id: item.id,
        firstName: item.firstName,
        lastName: item.lastName,
        fullName: item.fullName,
        company: item.company,
        companyPeriod: item.companyPeriod,
        emailId: item.emailId,
        contactNumber: item.contactNumber,
        location: item.location,
        linkedIn: item.linkedIn,
        formattedSkills: item.formattedSkills,
        applicantCode: item.applicantCode,
      };
      setShowAppliantDetailsById(appliantObj);
      scrollToElement("applicant-new");
      dispatch(setSelectedApplicant({ applicantDetails: appliantObj }));
      // Push history state to enable back button navigation
      navigate(location.pathname, { //+ location.search
        state: { selectedApplicant: appliantObj },
      });
    } else if (type === "newTab") {
      window.open(`/ats/layout/applicants/view/${item.id}`, "_blank");
    }
  };

  const handleCheckboxChange = (applicant, isChecked) => {
    if (isChecked) {
      setSelectedApplicantIds([...SelectedApplicantIds, applicant]);
    } else {
      setSelectedApplicantIds(
        SelectedApplicantIds.filter((item) => item.id !== applicant.id),
      );
    }
    applicantsList.find((item) => item.id === applicant.id).isChecked =
      isChecked;
    setApplicantsList([...applicantsList]);
  };

  const handleSearch = (query, type, page = 1) => {
    setSearchQuery(query);
    if (query !== "" && query.length >= 2 && type === "onRequestSearch") {
      let offSet = page !== 1 ? (page - 1) * config.limitData + 1 : page;
      dispatch(
        _ser.searchApplicantsWithPagingAsync(config.limitData, offSet, query),
      );
    } else if (query.length < 2 && type === "onRequestSearch") {
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Required Minimum 2 Characters",
        }),
      );
    } else if (query === "") {
      if (advancedSearch && Object.keys(advancedSearch).length > 0) {
        setConfig({ ...config, currentPage: 1 });
        handleApplyAdvancedSearch(
          advancedSearch,
          advancedSearchObj || {},
          1,
        );
      } else {
        dispatch(_ser.getListApplicantsAsync(config.limitData, 1));
        let modifyConfig = { ...config };
        modifyConfig.currentPage = 1;
        setConfig(modifyConfig);
        dispatch(resetHighlightFilter());
      }
    }
  };

  useEffect(() => {
    localStorage.removeItem("OverwriteEditObj");
    FetchData({ current: config.currentPage, offset: users.length + 1 });
    // Initialize user info and config
    const userInfo = GetUserInfo();
    const updatedConfig = userInfo
      ? (() => {
        const newConfig = { ...config };
        let updatedInlineOptions = ApplicantListfloatingMenuOptions?.inline;
        let updatedMenuOptions =
          ApplicantListfloatingMenuOptions?.menuOptions;
        if (
          userInfo[0]?.systemroles === "Standard User" ||
          isFieldRecruiter
        ) {
          newConfig.isDropdownActions = true;
          updatedInlineOptions = updatedInlineOptions.filter(
            (a) => a.action !== "delete",
          );
        }
        if (
          userInfo[0]?.projectStatus === null ||
          userInfo[0]?.projectStatus === 0 ||
          isFieldRecruiter
        ) {
          updatedInlineOptions = updatedInlineOptions.filter(
            (a) => a.action !== "addToProject",
          );
        }

        const integrations = userInfo[0]?.integrations
          ? JSON.parse(userInfo[0].integrations)
          : [];
        const ringCentralIntegration = integrations.find(
          (i) =>
            i.attribute_5 === "Ring Central" &&
            i.attribute_3?.includes("Messages"),
        );

        if (
          !integrations ||
          !ringCentralIntegration ||
          ringCentralIntegration.active === null ||
          isFieldRecruiter
        ) {
          updatedInlineOptions = updatedInlineOptions.filter(
            (a) => a.action !== "sendSMS",
          );
        }

        if (userInfo[0]?.systemroles === "Field Recruiter") {
          updatedMenuOptions = updatedMenuOptions.filter(
            (a) => a.action === "createManually",
          );
        }
        newConfig.menuOptions = updatedMenuOptions;
        newConfig.inlineOptions = updatedInlineOptions;
        return newConfig;
      })()
      : "";
    setConfig(updatedConfig);
    // Reset document upload reducer
    dispatch(_ser.uploadDocumentsStartReducer(initalState));

    // Helper to apply keyword filters
    const applyKeywordFilters = (keywords) => {
      if (Object.keys(keywords).length > 0) {
        setIsAdvancePannel(true);
        handleApplyAdvancedSearch(keywords, {}, 1);
      } else {
        setIsAdvancePannel(false);
      }
    };

    applyKeywordFilters(advSearchParams);
  }, []);

  const FetchData = async (obj) => {
    setUsers([]);
    let configure = JSON.parse(JSON.stringify(config));
    configure.currentPage = obj.current;
    configure.totalRecordsCount = 0;
    setConfig(configure);
    dispatch(_ser.getListApplicantsAsync(config.limitData, obj.offset));
  };

  const DelApplicantscode = useSelector((state) => state.DeleteApplicants.data);
  const DeleteRecords = async (object) => {
    let ids;
    if (typeof object === "object" && object.length > 0) {
      ids = object.map((x) => x.id.toString());
    } else {
      ids = [object.toString()];
    }
    const userId = await GetUserId();
    let obj = { ids: ids, Customerid: userId };
    dispatch(_ser.deleteApplicantsAsync(obj));
  };

  useEffect(() => {
    if (DelApplicantscode === 200) {
      let obj1 = {
        current: config.currentPage,
        offset:
          config.currentPage !== 1
            ? (config.currentPage - 1) * config.limitData + 1
            : config.currentPage,
      };
      FetchData(obj1);
      // setFilterValue('');
      dispatch(_ser.deleteApplicantsStartReducer(initalState));
    }
  }, [DelApplicantscode, config.currentPage, config.limitData]);

  const onReceiveActionHandler = async (type, object) => {
    setComponentType(type);
    handleTooltipDismiss();
    // setOpenFloatingMenu(false);
    if (type === "delete" || type === "addToProject" || type === "sendSMS") {
      if (SelectedApplicantIds.length === 0) {
        setComponentType("");
        dispatch(
          updateSnackbar({ type: "error", message: "No record selected" }),
        );
        return;
      } else if (type === "delete") {
        setWarningPopupDetails(warningPopupEnum.DELETE);
        setShowDeleteConfirm(true);
      }
    } else if (type === "download") {
      alert("download option is not implemented!");
    } else if (type === "newApplicants") {
      setIsRightSidePannel(object);
      dispatch(_ser.setSelectedJobDetailsStartReducer(initalState));
    } else if (type === "uploadExcel") {
      setIsRightSidePannel(object);
    } else if (type === "createManually") {
      navigate("/ats/layout/applicants/create-new", {
        state: { createManually: true },
      });
    }
    if (type === "addToProject") {
      if (SelectedApplicantIds.length >= 1) {
        setIsRightSidePannel(object);
      }
    }
    if (type === "sendSMS") {
      setIsRightSidePannel(object);
    }
  };

  const handleActionClick = (obj) => {
    const modifyConfig = { ...config };
    modifyConfig.currentPage = obj;
    modifyConfig.offset = obj !== 1 ? (obj - 1) * config.limitData + 1 : 1;
    setConfig(modifyConfig);
    if (advancedSearch === null && searchQuery == "") {
      dispatch(
        _ser.getListApplicantsAsync(
          modifyConfig.limitData,
          modifyConfig.offset,
        ),
      );
    } else if (advancedSearch && searchQuery == "") {
      // navigate(location.pathname + location.search, {
      //   replace: true,
      //   state: null,
      // });
      handleApplyAdvancedSearch(advancedSearch, advancedSearchObj || {}, obj);
    } else if (searchQuery !== "" && advancedSearch === null) {
      handleSearch(searchQuery, "onRequestSearch", obj);
    }
    scrollToElement("applicant-new");
    handleTooltipDismiss();
  };

  const handleConfirmDelete = async () => {
    setShowDeleteConfirm(false);
    if (SelectedApplicantIds.length > 0) {
      if (SelectedApplicantIds.length === applicantsList.length && config.currentPage > 1) {
        let modifyConfig = { ...config };
        modifyConfig.currentPage = config.currentPage - 1;
        modifyConfig.offset = (modifyConfig.currentPage - 1) * config.limitData + 1;
        setConfig(modifyConfig);
      }
      DeleteRecords(SelectedApplicantIds);
      setSelectedApplicantIds([]);
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirm(false);
  };

  const onReceivePropsHandler = (type) => {
    if (type === "close" || type === "close-details") {
      if (location.state?.selectedApplicant && type === "close") {
        // If we opened via history state, just go back
        navigate(-1);
      } else {
        // Fallback or for URL-based selection
        setShowAppliantDetailsById(null);
        setMinimiseRightSection(false);
        dispatch(resetSelectedApplicant());
        dispatch(_ser.getListApplicantsStartReducer(initalState));
        dispatch(_ser.uploadDocumentsStartReducer(initalState));
        navigate(location.pathname, { replace: true, state: null }); //+ location.search
        setAdvancedSearch((prev) => {
          const hasAdvancedSearch = prev && Object.keys(prev).length > 0;
          setIsAdvancePannel(hasAdvancedSearch);
          if (!hasAdvancedSearch) {
            dispatch(resetHighlightFilter());
          }
          return prev;
        });
      }
    } else if (type === "reload") {
      setAdvancedSearch(null);
      setAdvancedSearchObj(null);
      dispatch(resetHighlightFilter());
      setSearchQuery("");
      dispatch(_ser.getListApplicantsAsync(config.limitData, config.offset));
    } else if (type === "changeAppliant") {
      setIsResetTabs(false);
    }
  };

  useEffect(() => {
    const isCardInCurrentList = applicantsList?.some(
      (item) => item.id === showAppliantDetailsById?.id,
    );
    if (
      showAppliantDetailsById?.id &&
      isCardInCurrentList &&
      cardRefs.current[showAppliantDetailsById?.id]
    ) {
      cardRefs.current[showAppliantDetailsById?.id].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else if (gridRef.current) {
      gridRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [showAppliantDetailsById, applicantsList]);

  /* ---------------- JSX ---------------- */
  return (
    <div id="applicant-new">
      <div style={{ marginTop: isMobile ? "56px" : "80px" }}>
        <div
          style={{
            background: "#fff",
            padding: isMobile
              ? "12px 12px 60px"
              : !isAdvancePannel
                ? "22px 47px 47px"
                : "22px 47px 47px 0",
            minHeight: isMobile ? "calc(100vh - 80px)" : "calc(100vh - 150px)",
          }}
        >
          {/* HEADER WITH SEARCH, ADD BUTTON, AND ADVANCED SEARCH - ALL IN ONE LINE */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "30px",
              gap: "15px",
              width: "100%",
            }}
          >
            {/* ADVANCED SEARCH BUTTON - LEFT */}
            {!minimiseRightSection && !isFieldRecruiter && (
              <div
                className={
                  Boolean(config.isDropdownActions) || isAdvancePannel
                    ? "advanceSearchbtn"
                    : "advanceSearchbtn"
                }
              >
                <button
                  style={{
                    marginLeft: !isAdvancePannel ? "0" : "31px",
                    position:
                      !isAdvancePannel && showAppliantDetailsById === null
                        ? "absolute"
                        : "fixed",
                  }}
                  onClick={() => {
                    if (showAppliantDetailsById !== null) {
                      setIsAdvancePannel(true);
                      setShowAppliantDetailsById(null);
                      setMinimiseRightSection(false);
                      dispatch(resetSelectedApplicant());
                      navigate(location.pathname, {
                        replace: true,
                        state: null,
                      });
                    } else {
                      setIsAdvancePannel((prev) => !prev);
                    }
                  }}
                >
                  <img
                    src={process.env.PUBLIC_URL + "/assests/panel.svg"}
                    alt="advanced search btn"
                  />
                  Advanced search
                </button>
              </div>
            )}

            {/* SEARCH FIELD - CENTER */}
            {showAppliantDetailsById === null && (
              <div>
                <TextField
                  placeholder="Search By Applicant Name, Email ID, Contact Number"
                  value={searchQuery}
                  size="small"
                  onChange={(e) => handleSearch(e.target.value, "onChange")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      let modifyConfig = { ...config };
                      modifyConfig.currentPage = 1;
                      setConfig(modifyConfig);
                      handleSearch(e.target.value, "onRequestSearch");
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: "#9e9e9e" }} />
                      </InputAdornment>
                    ),
                    endAdornment: searchQuery && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => handleSearch("", "onCancelSearch")}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    width: "100%",
                    maxWidth: "480px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "24px",
                      width: "480px",
                      height: "42px",
                      backgroundColor: "#ffffff",
                      "& fieldset": {
                        borderColor: "#B8B8B8",
                      },
                      "&:hover fieldset": {
                        borderColor: "#B8B8B8",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#B8B8B8",
                      },
                    },
                    "@media (max-width: 768px)": {
                      maxWidth: "100%",
                      "& .MuiOutlinedInput-root": {
                        height: "36px",
                      },
                    },
                  }}
                />
              </div>
            )}
            {showAppliantDetailsById === null && (
              <FloatingMenu
                config={config}
                floatingMenuOptions={ApplicantListfloatingMenuOptions}
                onReceiveActionHandler={onReceiveActionHandler}
                storedTheme={storedTheme}
              />
            )}
          </Box>

          {showAppliantDetailsById !== null && (
            <img
              src={!minimiseRightSection ? process.env.PUBLIC_URL +
                "/assests/img/advance-search-minimise.svg" : process.env.PUBLIC_URL +
              "/assests/img/minimise.svg"
              }
              alt=""
              className="advance-search-minimise"
              style={{
                left: minimiseRightSection ? "52px" : "25.5%",
                marginTop: minimiseRightSection ? "-42px" : "-45px",
              }}
              onClick={(e) => {
                setMinimiseRightSection(!minimiseRightSection);
              }}
            />
          )}

          {/* MAIN LAYOUT */}
          <div className="d-flex">
            <AdvancedSearch
              isOpen={isAdvancePannel}
              onClose={handleCloseAdvancedSearch}
              onApplyFilter={handleApplyAdvancedSearch}
              customFieldsData={customFieldsData}
              recruiterList={recruiterList}
              storedTheme={storedTheme}
              onClearFilters={handleClearAdvancedFilters}
            />

            {/* RIGHT SIDE – CARDS */}
            <div
              className={
                showAppliantDetailsById !== null ? "cards-sidebar-wrapper" : ""
              }
              style={{
                width:
                  showAppliantDetailsById === null
                    ? isAdvancePannel
                      ? "80%"
                      : "100%"
                    : minimiseRightSection
                      ? "0"
                      : "27%",
                position: "relative",
              }}
            >
              {showAppliantDetailsById === null && (
                <span style={{ marginBottom: "15px", display: "block" }}>
                  <b>Total Applicants </b>
                  <span key={config.totalRecordsCount}>
                    - {config.totalRecordsCount}
                  </span>
                </span>
              )}
              <div
                className={
                  showAppliantDetailsById !== null
                    ? "rightside-cards-section"
                    : ""
                }
                style={{ display: minimiseRightSection ? "none" : "block" }}
              >
                <Grid
                  container
                  spacing={3}
                  ref={gridRef}
                  style={{
                    minHeight: "calc(100vh - 250px)",
                    height:
                      config.totalRecords < 9 &&
                        showAppliantDetailsById !== null
                        ? "calc(100vh - 163px)"
                        : "",
                  }}
                >
                  {applicantsList && applicantsList.length > 0
                    ? applicantsList.map((item, index) => {
                      const isViewDetails =
                        showAppliantDetailsById === null ? false : true;
                      return (
                        <Grid
                          item
                          xs={12}
                          sm={isViewDetails ? 12 : 6}
                          md={isViewDetails ? 12 : 4}
                          key={item.id}
                          ref={(el) => {
                            if (el) cardRefs.current[item.id] = el;
                          }}
                        >
                          <NewApplicantCard
                            data={item}
                            selectedCard={showAppliantDetailsById}
                            onEventHandler={(type) =>
                              onReceivepropsHandler(item, type)
                            }
                            onCheckboxChange={handleCheckboxChange}
                            isAdvancePannel={isAdvancePannel}
                            isFirst={config.currentPage === 1}
                            tooltipCardId={tooltipCardId}
                            showSelectAllTip={showSelectAllTip}
                            onTooltipDismiss={handleTooltipDismiss}
                            setTooltipCardId={setTooltipCardId}
                            onDoubleClick={() => {
                              handleSelectAll(!item.isChecked);
                            }}
                          // selectedForDelete={SelectedApplicantIds}
                          />
                        </Grid>
                      );
                    })
                    : showNoData && (
                      <Box
                        sx={{
                          width: "100%",
                          padding: "20px",
                          textAlign: "center",
                        }}
                      >
                        <div className="detail-card-empty no-data-card">
                          <img
                            src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                            alt="No data"
                          />
                          No applicants found
                        </div>
                      </Box>
                    )}
                </Grid>
                <div
                  className="applicant-list-count"
                  style={{
                    paddingTop: showAppliantDetailsById === null ? "7px" : "",
                    justifyContent: "end",
                    marginTop: showAppliantDetailsById === null ? "" : "0px",
                    marginRight: showAppliantDetailsById === null ? "" : "0px",
                  }}
                >
                  <Pagination
                    currentPage={config.currentPage}
                    totalCount={config.totalRecords}
                    pageSize={config.limitData}
                    onPageChange={(page) => handleActionClick(page)}
                  />
                </div>
                {showAppliantDetailsById === null && !isFieldRecruiter && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row-reverse",
                      marginBottom: "-20px",
                    }}
                  >
                    <ViewToggle view={"card"} type={"applicant"} />
                  </div>
                )}
              </div>
            </div>
            {/* VIEW COMPONENT */}
            {showAppliantDetailsById !== null && (
              <div
                className="applicant-detail-view-wrapper"
                style={{
                  width: minimiseRightSection ? "100%" : "73%",
                  marginLeft: isMobile ? "0" : "20px",
                  marginTop: minimiseRightSection
                    ? "-20px"
                    : isMobile
                      ? "0"
                      : "-50px",
                }}
              >
                <ApplicantsDetailsTabs
                  onResetTabs={isResetTabs}
                  showAppliantDetailsById={showAppliantDetailsById?.isOpenedInNewTab ? showAppliantDetailsById?.id : null }
                  onReceiveProps={(type) => {
                    onReceivePropsHandler(type);
                  }}
                />
              </div>
            )}
            {isRightSidePannel && (
              <div>
                <ApplicantsCreateFlow
                  componetType={componetType}
                  setComponentType={setComponentType}
                  selectedApplicantsIds={SelectedApplicantIds}
                  setSearchFilter={setSearchQuery}
                // onReceiveProps={(componetType) =>
                //   onReceiveActionHandler(componetType)
                // }
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* DELETE CONFIRMATION DIALOG */}
      <Dialog
        open={showDeleteConfirm}
        keepMounted
        onClose={handleCancelDelete}
        aria-describedby="alert-dialog"
        PaperProps={{
        style: {
          borderRadius: "10px",
          overflow: "hidden",
          bottom: "18%",
        },
      }}
      >
        <Box sx={{ width: "442px" }}>
          <DialogTitle className="diabtn-dark">Confirm Deletion</DialogTitle>
          <DialogContent style={{ padding: "40px 20px" }}>
            <DialogContentText id="primary-dialog">
              <p className="btntext"
                style={{
                  textAlign: "center",
                  color: "#000",
                  fontSize: "18px",
                  margin: 0,
                }}
              >{warningPopupDetails.title}</p>
              <p className="btntext"
                style={{
                  textAlign: "center",
                  color: "#000",
                  fontSize: "18px",
                  margin: 0,
                }}
              >{warningPopupDetails.title1}</p>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="alert-actionbtns">
            <Button onClick={handleCancelDelete}>Cancel</Button>
            <Button onClick={handleConfirmDelete}>
              {warningPopupDetails.btnName}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </div>
  );
};
export default ApplicantsList;
